jQuery.extend({
    ShowLoading: function (loadingContainerSelector) {
        var control = jQuery("#nhs_Loading,#nhs_Overlay");
        if (control.length === 0) {
            var overlay = jQuery('<div id="nhs_Overlay" style="position: fixed;z-index:99999;top: 0px;left: 0px;height:100%;width:100%;background-color: #000;filter: alpha(opacity=35);-moz-opacity: 0.35;opacity: 0.35;"></div>');
            var loading = jQuery('<div id="nhs_Loading" class="nhs_Loading"><p>Updating</p></div>');
            const containerForLoading = document.querySelector(loadingContainerSelector);
            if (containerForLoading) {
              containerForLoading.appendChild(overlay[0]);
              containerForLoading.appendChild(loading[0]);
            } else {
              jQuery("body").append(overlay);
              jQuery("body").append(loading);
            }
            loading.show();
            overlay.show();
        } else {
            control.show();
        }
    },

    HideLoading: function (loadingContainerSelector) {
      let overlayElement = null;
      let loadingElement = null;
      if (loadingContainerSelector) {
        overlayElement = document.querySelector(`${loadingContainerSelector} #nhs_Overlay:not([data-role="map-overlay"])`);
        loadingElement = document.querySelector(`${loadingContainerSelector} #nhs_Loading:not([data-role="map-overlay"])`);
      } else {
        overlayElement = document.querySelector('#nhs_Overlay:not([data-role="map-overlay"])');
        loadingElement = document.querySelector('#nhs_Loading:not([data-role="map-loading"])');
      }

      if (overlayElement) {
        overlayElement.remove();
      }

      if (loadingElement) {
        loadingElement.remove();
      }
    }
});

jQuery.fn.extend({
    ScrollTo: function (targetOffset) {
        if (typeof targetOffset == "undefined")
            targetOffset = this.offset().top;
        jQuery.ScrollTo(targetOffset, false);
    },
    ScrollToPosLess: function (value) {
        var targetOffset = this.offset().top;
        jQuery.ScrollTo(targetOffset - value, false);
    },
    ScrollToFast: function (targetOffset) {
        if (typeof targetOffset == "undefined")
            targetOffset = this.offset().top;
        jQuery.ScrollTo(targetOffset, true);
    },
    ScrollClickTo: function (targetOffset) {
        var self = this;
        this.click(function (mozEvent) {
            var ev = mozEvent ? mozEvent : window.event; //Moz support requires passing the event argument manually     
            //Cancel the event   
            ev.cancelBubble = true;
            ev.returnValue = false;
            if (ev.stopPropagation) ev.stopPropagation();
            if (ev.preventDefault) ev.preventDefault();
            self.ScrollTo(targetOffset);
        });
        return this;
    }
});

jQuery.extend({
    ScrollToFast: function (targetOffset) {
        if (typeof targetOffset === "undefined")
            targetOffset = this.offset().top;
        this.ScrollTo(targetOffset, true);
    },
    ScrollTo: function (targetOffset, fast, callBak) {
        var scrollElem = jQuery.scrollableElement(['html', 'body']);
        if (fast) {
            jQuery(scrollElem).scrollTop(targetOffset);
            if (jQuery.isFunction(callBak))
                callBak();
        } else {
            jQuery(scrollElem).animate({ scrollTop: targetOffset }, "slow", callBak);
        }
    },
    
    scrollableElement: function (els) {
        for (var j = 0; j < els.length; j++) {
            var el = els[j];
            var $scrollElement = jQuery(el);
            if ($scrollElement.scrollTop() > 0) {
                return el;
            } else {
                $scrollElement.scrollTop(1);
                var isScrollable = $scrollElement.scrollTop() > 0;
                $scrollElement.scrollTop(0);
                if (isScrollable) {
                    return el;
                }
            }
        }
        return [];
    }
});